var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { injectStores } from '../../util/StoresUtil';
import { format } from 'date-fns';
let RepresentationRightsValidUntil = class RepresentationRightsValidUntil extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    render() {
        const { translate } = this.translateStore;
        const mandate = this.getMandateWithLatestValidUntilDate();
        return (React.createElement("span", null, (mandate && mandate.validUntil && format(new Date(mandate.validUntil), 'dd.MM.yyyy')) || translate('personPowers.mandate.unlimitedValidity')));
    }
    getMandateWithLatestValidUntilDate() {
        const { mandates } = this.props;
        if (mandates.length > 1) {
            return mandates.reduce((prev, next) => (prev.validUntil > next.validUntil ? prev : next));
        }
        return mandates[0];
    }
};
RepresentationRightsValidUntil = __decorate([
    injectStores,
    observer
], RepresentationRightsValidUntil);
export default RepresentationRightsValidUntil;
